/* eslint-disable css-modules/no-unused-class  */
import { Divider, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './overallAchievements.module.scss';

const OverallAchievements: FC<OverallAchievementsProps> = (props: OverallAchievementsProps) => {
    const { framework, strongCategories, poorCategories, winnerText, rank, totalUsers, score } = props;

    const strongEmptyText = translate('strongEmptyText');
    const poorEmptyText = translate('poorEmptyText');

    return (
        <div className={styles['overall-tournament-wrapper']}>
            <div className={styles['left-wrapper']}>
                <div className={styles.box}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/winnerBackground.svg`}
                        className={styles.image}
                        alt="overAllAchivements"
                    />
                    <div className={styles.title}>{translate('Winner')}</div>
                    <div className={styles.value}>{winnerText}</div>
                </div>
                <div className={styles.box}>
                    <div className={styles.title}>{translate('Rank')}</div>
                    <div className={styles.value}>{`${rank}/${totalUsers}`}</div>
                </div>
            </div>
            <Divider orientation="vertical" className={styles['tournament-divider']} color="rgba(255, 255, 255, 0.2)" />
            <div className={styles.right}>
                <div className={styles.top}>
                    <div className={styles.performance}>{translate('GeneralOverview')}</div>
                    <div className={styles.score}>
                        <Icon name="devCoin" />
                        <div>{score.toLocaleString()}</div>
                    </div>
                </div>
                <Divider
                    className={styles['performance-divider']}
                    orientation="horizontal"
                    color="rgba(255, 255, 255, 0.2)"
                />
                <div className={styles['performance-categories']}>
                    <div className={styles.framework}>
                        <div className={styles['framework-title']}>{translate('Framework')}</div>
                        <div key="framework" className={styles.subtitle} title={framework}>
                            {framework}
                        </div>
                    </div>
                    <Divider
                        orientation="vertical"
                        className={styles['categories-divider']}
                        color="rgba(255, 255, 255, 0.2)"
                    />
                    <div className={styles['strong-category']}>
                        <div className={styles['strong-title']}>{translate('Strong')}</div>
                        {strongCategories.length > 0 ? (
                            strongCategories.map((subtitle, index) => (
                                <div key={index} className={styles.subtitle} title={subtitle}>
                                    {subtitle}
                                </div>
                            ))
                        ) : (
                            <div className={styles['empty-state']}>
                                <Icon name="showThem" isPng />
                                <div className={styles['empty-state-text']}>{strongEmptyText}</div>
                            </div>
                        )}
                    </div>
                    <Divider
                        orientation="vertical"
                        className={styles['categories-divider']}
                        color="rgba(255, 255, 255, 0.15)"
                    />
                    <div className={styles['poor-category']}>
                        <div className={styles['poor-title']}>{translate('Poor')}</div>
                        {poorCategories.length > 0 ? (
                            poorCategories.map((subtitle, index) => (
                                <div key={index} className={styles.subtitle} title={subtitle}>
                                    {subtitle}
                                </div>
                            ))
                        ) : (
                            <div className={styles['empty-state']}>
                                <Icon name="stillGotThis" isPng />
                                <div className={styles['empty-state-text']}>{poorEmptyText}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface OverallAchievementsProps {
    framework: string;
    score: number;
    winnerText: string;
    strongCategories: string[];
    poorCategories: string[];
    rank: number;
    totalUsers: number;
}

export default OverallAchievements;
